import { render, staticRenderFns } from "./wkBlockText.vue?vue&type=template&id=1cdf3ae5&scoped=true"
import script from "./wkBlockText.vue?vue&type=script&lang=js"
export * from "./wkBlockText.vue?vue&type=script&lang=js"
import style0 from "./wkBlockText.vue?vue&type=style&index=0&id=1cdf3ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdf3ae5",
  null
  
)

export default component.exports